import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { orgApi } from "api/org";

/**
 * Onboarding gate (Sprint 9, Part 89 §89.5): dashboard routes redirect to
 * the 10-minute onboarding wizard until the org has set its WhatsApp phone
 * and has data. The first AI follow-up is a nudge, not a gate (Sprint 15
 * QA) — it needs a lead untouched for 24h. All steps are read from the
 * backend (GET /api/org/onboarding) — nothing is stored client-side.
 */
export default function OnboardingGate({ children }) {
  const [state, setState] = useState({ loading: true, complete: false });

  useEffect(() => {
    let active = true;
    orgApi
      .getOnboarding()
      .then((status) => {
        if (active) setState({ loading: false, complete: status?.complete ?? false });
      })
      .catch(() => {
        // Backend unreachable — let the page render and show its own error.
        if (active) setState({ loading: false, complete: true });
      });
    return () => {
      active = false;
    };
  }, []);

  if (state.loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "var(--color-background)" }}
      >
        <p className="font-caption text-sm" style={{ color: "var(--color-text-secondary)" }}>
          Checking setup...
        </p>
      </div>
    );
  }

  if (!state.complete) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
